import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { isStaffingCandidate } from '../../../api/dashboards-api';

function CandidateProfileHeader({ candidate, header, nameOnly = false, remoteStaffing = false }) {
  const [summarySuffix, setSummarySuffix] = useState('');

  useEffect(() => {
    if (!nameOnly) {
      if (isStaffingCandidate(candidate)) {
        if (remoteStaffing) {
          setSummarySuffix(' (REMOTE)');
        } else {
          setSummarySuffix(' (ONSITE/HYBRID)');
        }
      }
    }
  }, [candidate]);
  return (
    <Container>
      {candidate && (
        <>
          <Row className="text-smaller justify-content-center candidate-profile-title">{header}</Row>
          <Row className="justify-content-center pt-1 pb-1 candidate-profile-candidate-name">
            {candidate.name}
            {summarySuffix}
          </Row>
        </>
      )}
    </Container>
  );
}

export default CandidateProfileHeader;
